
import {
    get,
    post,
    del
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增专项资金申请
export function addApplicationSpecialFunds(params) {
    return post(`${HOST}application-special-funds/save`, params)
}
// 修改专项资金申请
export function updateApplicationSpecialFunds(params) {
    return post(`${HOST}application-special-funds/update`, params)
}
//专项资金申请列表
export function getApplicationSpecialFunds(params) {
    return get(`${HOST}application-special-funds/list`, params)
}
//专项资金申请草稿箱列表
export function ApplicationSpecialFundsDraftlist(params) {
    return get(`${HOST}application-special-funds/draftlist`, params)
}
//专项资金申请详情
export function ApplicationSpecialFundsDetial(params) {
    return get(`${HOST}application-special-funds/get`, params)
}
// 删除专项资金申请
export function delApplicationSpecialFunds(params) {
    return del(`${HOST}application-special-funds/delete`, params)
}







// WEBPACK FOOTER //
// ./src/views/MoneyToApply/api/api.js